// extracted by mini-css-extract-plugin
export default {"confirmButton":"unsubscribe_confirmButton__JYaK5"};